module.exports = __webpack_public_path__ + "img/copy.b3ee71b0.svg";